function setResponsiveBackgrounds() {
    // Select all elements with the class 'bgimage'
    const bgElements = document.querySelectorAll('.main-slider .slide-image');
    const screenWidth = window.innerWidth || document.documentElement.clientWidth;
    // Define your mobile breakpoint (e.g., 768px)
    const mobileBreakpoint = 767; 

    /*bgElements.forEach(element => {
        const desktopImg = element.getAttribute('desktopimg');
        const mobileImg = element.getAttribute('mobileimg');
        let imageUrl = '';

        // Check if the mobile image attribute is not empty and screen is mobile width
        if (screenWidth <= mobileBreakpoint && mobileImg) {
            imageUrl = mobileImg;
        } else if (desktopImg) {
            // Default to desktop image for larger screens
            imageUrl = desktopImg;
        }

        // Apply the background image if a URL was found
        if (imageUrl) {
            // Set the background image style using single quotes within the url() function
            element.style.backgroundImage = `url('${imageUrl}')`;
        }
    });*/
    
    if (screenWidth <= mobileBreakpoint) {
        jQuery(".section-slideshow .slide-image.desktop").css('display','none');
        jQuery(".section-slideshow .slide-image.mobile").css('display','block');
    } else {
        jQuery(".section-slideshow .slide-image.desktop").css('display','block');
        jQuery(".section-slideshow .slide-image.mobile").css('display','none');
    }
    
}

// Run on initial load
document.addEventListener('DOMContentLoaded', setResponsiveBackgrounds);
// Run on window resize for responsiveness
window.addEventListener('resize', setResponsiveBackgrounds);